<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17gm4ce/images/cover.jpg?1685327176265" alt="This image is the cover for the book No Angel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">No Angel
      </h1>
      <p class="bookDescription body article font2">
        <p>Born with a birth defect called Devil Syndrome, it is impossible for Josh Harper to hide the two small stumps of hornlike bone atop his head. If people also knew about his ability to create force fields with his mind, they’d lock him up for sure. Left to fend for himself on his eighteenth birthday, Josh tries to make it on the streets. When he’s attacked, he’s rescued by Sam Mitchell, who has an equally strange power—and a set of pure white wings.</p> <p>Sam ran away from home a year ago, and the new life he’s built for himself includes living in an abandoned house and looking after three younger kids, all with Devil Syndrome. Then along comes Josh. After a rough start their relationship grows and the two young men find a haven in each other’s arms. But when tragedy strikes their newfound family, Sam’s hatred of regular humans spirals out of control, and Josh will have to make Sam see sense before everything he’s worked so hard to build is destroyed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Daniel A. Kaine
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d72a75a